/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

const useRequest = (actionPairs) => {
    if (!actionPairs || !Array.isArray(actionPairs))
        throw new Error('actionPairs must be provided and must be of type Array');

    if (actionPairs.some(({ selector, action }) => !selector || !action))
        throw new Error('each actionPair needs a selector and action');

    if (actionPairs.some(({ action }) => !action.type))
        throw new Error('each action needs a type, did you forget to execute it?');

    const dispatch = useDispatch();
    const results = actionPairs.map(({ selector, statusKey, action, when = true }) => {
        const requestSelector = statusKey ? (state) => selector(state)[statusKey] : (state) => selector(state);
        const selectorOutput = useSelector(requestSelector);
        const { isInitial } = selectorOutput;
        useEffect(() => {
            if (isInitial && when) dispatch(action); // action changes per-render, so is excluded from the array below
        }, [isInitial, statusKey, when]); // eslint-disable-line react-hooks/exhaustive-deps
        return {
            ...selectorOutput,
            retry: action,
        };
    });

    // initial if one is initial
    const isInitial = results.some((result) => result.isInitial);

    // pending if one is pending
    const isPending = results.some((result) => result.isPending);

    // fail on a single failure
    const hasFailed = results.some((result) => result.hasFailed);

    // success when all succeed
    const isComplete = actionPairs.length > 0 && results.every((result) => result.isComplete);

    // all failed actions to allow UI to hook into retries
    const failedActions = actionPairs.filter(({ selector, statusKey }) => {
        const requestSelector = statusKey ? (state) => selector(state)[statusKey] : (state) => selector(state);
        return useSelector(requestSelector).hasFailed;
    });

    return {
        isInitial,
        isPending,
        hasFailed,
        isComplete,
        failedActions,
    };
};

export default useRequest;
